import React, { Component } from 'react'
import {Cards,Chart,CountryPicker} from './components'
import { fetchData } from './components/api'
import "./tailwind.css"

export default class App extends Component {
    state ={
       data:{},
       country:''
    }
    async componentDidMount(){
       const fetchedData =  await fetchData();
        this.setState({data:fetchedData})
    }

    handleCountry = async (country)=>{
        const fetchedData =  await fetchData(country)
        this.setState({data:fetchedData, country})
    }
    render() {
        const {data, country} = this.state
        return (
            <div className="mx-5 sm:w-4/6 sm:mx-auto ">

                <h1 className=" text-3xl sm:text-5xl text-center relative text-gray-700  font-semibold mt-12 mb-4">
                    COVID-19 Tracker <sup><span className="bg-red-600 text-white text-sm px-3 py-1 rounded-full animate-pulse">Live</span></sup>
                </h1>

                <Cards data={data}></Cards>
                <CountryPicker handleCountryChange={this.handleCountry}/>
                <Chart data={data} country={country}/>

                <div className="text-lg text-center my-10 flex flex-col">
                    <span>Made in ❤ with <span className="font-semibold text-orange-600">India</span></span> 
                    <div> Built by <a className="font-semibold text-blue-600" href="https://tusharmangle.netlify.app">Tushar Mangle</a></div>
                    </div>
            </div>
        )
    }
}
